import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogTitle,
  Paper,
} from "@mui/material";
import { Stack } from "@mui/system";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DeleteReceiptTable from "./DeleteReceiptTable";

interface DeleteReceiptProps {
  open: boolean;
  handleClose: () => void;
}

const tableHeadings = {
  company: "Company",
  receipt_number: "Receipt Number",
  receipt_amount: "Receipt Amount",
  fme: "FME",
  credit: "Credit",
  debit: "Debit",
  covered: "% Covered",
  fme_status: "Receipt Status",
};
const rows = [
  {
    company: "Boyle",
    receipt_number: "RC259001039",
    receipt_amount: "174.35",
    fme: "5325",
    credit: "2445.4",
    debit: "174.35",
    covered: "22%",
    fme_status: "Dispute",
  },
];

const DeleteReceiptModal = ({ open, handleClose }: DeleteReceiptProps) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { width: "1000px", maxWidth: "1000px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            Delete Receipt?
          </DialogTitle>

          <Alert
            severity="warning"
            icon={<ErrorOutlineIcon sx={{ color: "rgba(237, 108, 2, 1)" }} fontSize="inherit" />}
             sx={{
                border: "1px solid rgba(237, 108, 2, 0.5)",
                color:'rgba(237, 108, 2, 1)',
                alignItems:'center'
              }}
          >
            <AlertTitle>
              This action can’t be undone, and the receipt will be permanently
              removed from your records.
            </AlertTitle>
            This action will also break the linkage to ant existing FME
          </Alert>

          <DeleteReceiptTable tableHeadings={tableHeadings} rows={rows} />

          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button color="secondary" variant="outlined" onClick={handleClose}>
              CANCEL
            </Button>
            <Button
              sx={{ ml: 2 }}
              color="secondary"
              variant="contained"
              onClick={handleClose}
            >
              DELETE anyway
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default DeleteReceiptModal;
